export default {
  // area: '西南隅社区',
  // objectName: '',
  //url
  // hostUrl : 'http://cuiyun.dexian.ren/',
  // apiHttpsUrl: 'https://jlhyjd.anluoyun.cn/prod-api',
  // apiRequestUrl: 'https://jlhyjd.anluoyun.cn/prod-api',
  // apiUploadUrl: 'https://lyxnyapi.dexian.ren/api/UploadFile/UploadImgs',
  // apiUploadFiles: 'https://lyxnyapi.dexian.ren/api/UploadFile/UploadFiles',
  // apiUploadvideo: 'https://lyxnyapi.dexian.ren/api/UploadFile/UploadQiniuVideo',

  apiHttpsUrl: 'http://192.168.1.20:8087',
  apiRequestUrl: 'http://192.168.1.20:8087',
  apiUploadUrl: 'https://lyxnyapi.dexian.ren/api/UploadFile/UploadImgs',
  apiUploadFiles: 'https://lyxnyapi.dexian.ren/api/UploadFile/UploadFiles',
  apiUploadvideo: 'https://lyxnyapi.dexian.ren/api/UploadFile/UploadQiniuVideo',
}
